// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cross-reactor-list :has(input:disabled) label {
  color: black;
  cursor: not-allowed;
}

.ingredient-type-ahead__input-group {
  height: 2.5rem;
}
.ingredient-type-ahead__input-group label {
  width: 100%;
}
.ingredient-type-ahead__input-group .input-group-text {
  background-color: #fff;
  border: 1px solid #e7edef;
  cursor: pointer;
}
.ingredient-type-ahead__input-group .input-group-prepend {
  background-color: #ffffff;
  border: 1px solid #e7edef;
  border-bottom-left-radius: 20px;
  border-top-left-radius: 20px;
  height: 2.5rem;
  justify-content: center;
  padding-top: 8px;
  position: relative;
  width: 50px;
}
.ingredient-type-ahead__input-group .ingredient-type-ahead__input {
  height: 2.5rem;
  width: 100%;
}
.ingredient-type-ahead__input-group .ingredient-type-ahead__input .form-control {
  height: 2.5rem;
  border-color: #e7edef;
  border-left: none;
  border-radius: 0;
  border-right: none;
  color: #00171f;
  height: 2.5rem;
  position: relative;
}
.ingredient-type-ahead__input-group .input-group-append > .btn {
  background-color: #ffffff;
  border: 1px solid #e7edef;
  border-left: none;
  box-shadow: none;
  width: 50px;
}
.ingredient-type-ahead__input-group .input-group-append > .btn:focus, .ingredient-type-ahead__input-group .input-group-append > .btn:hover, .ingredient-type-ahead__input-group .input-group-append > .btn:active, .ingredient-type-ahead__input-group .input-group-append > .btn:active:focus {
  background-color: #ffffff;
  border: 1px solid #e7edef;
  border-left: none;
  box-shadow: none;
  width: 50px;
}
.ingredient-type-ahead__input-group .btn.btn-secondary {
  background-color: #00889b;
  border-radius: 5px;
  margin-left: 15px;
  color: #ffffff;
  font-weight: 300;
}
.ingredient-type-ahead__input-group .btn.btn-secondary:focus, .ingredient-type-ahead__input-group .btn.btn-secondary:hover, .ingredient-type-ahead__input-group .btn.btn-secondary:active, .ingredient-type-ahead__input-group .btn.btn-secondary:active:focus {
  background-color: #00889b;
}

.ingredient-type-ahead__input {
  height: 2.5rem;
}
.ingredient-type-ahead__input .form-control {
  height: 2.5rem;
  border-color: #e7edef;
  border-left: none;
  border-radius: 0;
  border-right: none;
  color: #00171f;
  height: 2.5rem;
  position: relative;
}
.ingredient-type-ahead__input .form-control:before {
  position: absolute;
  top: -10px;
}

.table-container {
  border: solid 1px none;
  align-items: center;
  justify-content: center;
  height: 50vh;
  overflow-y: scroll;
}

.ingredient-component-text {
  font-size: 16px;
  line-height: 24px;
  color: #595e60;
  font-weight: 400;
  align-items: center;
  padding: 16px;
}

.ingredient-component-container-left {
  border-right: 1px solid #e4f1f0;
}

.ingredient-component-container-right {
  border-left: 1px solid #e4f1f0;
}

.ingredient-component-container {
  border: 1px solid #e4f1f0;
}

.custom-checkbox {
  font-size: 16px;
  line-height: 24px;
  color: #595e60;
  font-weight: 400;
  align-items: center;
  padding: 16px;
}
.custom-checkbox .input-checked {
  cursor: pointer;
  width: 16px;
  height: 16px;
  accent-color: #00889b;
}
.custom-checkbox .input-checked:checked::before {
  border: 2px solid #595e60;
}
.custom-checkbox .input-checked:checked::after {
  border: 3px solid #00889b;
}

.common-allergen-type-ahead {
  background-color: #f5fbff;
  border: solid 1px #414b4f;
}

.common-allergen__results {
  background-color: #f5fbff;
  box-shadow: 1px 1px 8px 0 rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  margin: auto 15px auto 0;
  position: absolute;
  z-index: 200;
  overflow-y: scroll;
  max-height: 40vh;
  width: 90%;
  top: 55px;
}
.common-allergen__results .ingredient__option-button {
  background-color: #f5fbff;
  border: none;
  box-shadow: none;
  color: #00171f;
  margin: 0;
  padding: 5px 20px;
  text-align: start;
  display: flex;
  flex: 1 1;
}
.common-allergen__results .ingredient__option-button mark {
  background-color: #00889b;
}
.common-allergen__results .ingredient__option-button:focus, .common-allergen__results .ingredient__option-button:hover, .common-allergen__results .ingredient__option-button:active, .common-allergen__results .ingredient__option-button:active:focus {
  background-color: #f5fbff !important;
  border: 1px solid #00171f !important;
  border-left: none;
  border-radius: 0;
  box-shadow: none;
  color: #00171f !important;
}
.common-allergen__results .ingredient__option-button .is-allergen {
  color: #ef6360;
  font-size: 12px;
}
.common-allergen__results .ingredient__results__none {
  padding: 20px;
  width: 100%;
}

.footer-button.btn.btn-secondary {
  background-color: #00889b !important;
  width: 150px;
  border-radius: 5px;
}

.loading-container {
  color: #00889b;
  justify-content: center;
  align-items: center;
  margin-top: -200px;
}`, "",{"version":3,"sources":["webpack://./src/pages/ingredient-review/CrossReactorList.scss","webpack://./src/styles/colors.scss","webpack://./src/styles/z-index.scss"],"names":[],"mappings":"AAIE;EACE,YAAA;EACA,mBAAA;AAHJ;;AAOA;EACE,cAAA;AAJF;AAME;EACE,WAAA;AAJJ;AAOE;EACE,sBAAA;EACA,yBAAA;EACA,eAAA;AALJ;AAQE;EACE,yBCnBI;EDoBJ,yBAAA;EACA,+BAAA;EACA,4BAAA;EACA,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AANJ;AASE;EACE,cAAA;EACA,WAAA;AAPJ;AAQI;EACE,cAAA;EACA,qBCtBgB;EDuBhB,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cC5CM;ED6CN,cAAA;EACA,kBAAA;AANN;AAUE;EACE,yBC9CI;ED+CJ,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AARJ;AAUI;EAIE,yBCxDE;EDyDF,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AAXN;AAeE;EACE,yBCzDU;ED0DV,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAbJ;AAcI;EAIE,yBClEQ;ADmDd;;AAoBA;EACE,cAAA;AAjBF;AAmBE;EACE,cAAA;EACA,qBCvEkB;EDwElB,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cC7FQ;ED8FR,cAAA;EACA,kBAAA;AAjBJ;AAoBE;EACE,kBAAA;EACA,UAAA;AAlBJ;;AAsBA;EACE,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;AAnBF;;AAsBA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;AAnBF;;AAsBA;EACE,+BAAA;AAnBF;;AAsBA;EACE,8BAAA;AAnBF;;AAsBA;EACE,yBAAA;AAnBF;;AAsBA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;AAnBF;AAqBE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,qBCpIU;ADiHd;AAqBI;EACE,yBAAA;AAnBN;AAsBI;EACE,yBAAA;AApBN;;AAyBA;EACE,yBAAA;EACA,yBAAA;AAtBF;;AAyBA;EACE,yBAAA;EACA,4CAAA;EACA,sBAAA;EACA,wBAAA;EACA,kBAAA;EACA,YExKiB;EFyKjB,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;AAtBF;AAwBE;EACE,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,cClLQ;EDmLR,SAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,SAAA;AAtBJ;AAwBI;EACE,yBC7KQ;ADuJd;AAyBI;EAIE,oCAAA;EACA,oCAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;AA1BN;AA6BI;EACE,cCtLO;EDuLP,eAAA;AA3BN;AA8BE;EACE,aAAA;EACA,WAAA;AA5BJ;;AAgCA;EACE,oCAAA;EACA,YAAA;EACA,kBAAA;AA7BF;;AAgCA;EACE,cC9MY;ED+MZ,uBAAA;EACA,mBAAA;EACA,kBAAA;AA7BF","sourcesContent":["@import \"../../styles/colors.scss\";\n@import \"../../styles/z-index.scss\";\n\n.cross-reactor-list {\n  :has(input:disabled) label {\n    color: black;\n    cursor: not-allowed;\n  }\n}\n\n.ingredient-type-ahead__input-group {\n  height: 2.5rem;\n\n  label {\n    width: 100%;\n  }\n\n  .input-group-text {\n    background-color: #fff;\n    border: 1px solid $form-control-border;\n    cursor: pointer;\n  }\n\n  .input-group-prepend {\n    background-color: $white;\n    border: 1px solid $form-control-border;\n    border-bottom-left-radius: 20px;\n    border-top-left-radius: 20px;\n    height: 2.5rem;\n    justify-content: center;\n    padding-top: 8px;\n    position: relative;\n    width: 50px;\n  }\n\n  .ingredient-type-ahead__input {\n    height: 2.5rem;\n    width: 100%;\n    .form-control {\n      height: 2.5rem;\n      border-color: $form-control-border;\n      border-left: none;\n      border-radius: 0;\n      border-right: none;\n      color: $site-text;\n      height: 2.5rem;\n      position: relative;\n    }\n  }\n\n  .input-group-append > .btn {\n    background-color: $white;\n    border: 1px solid $form-control-border;\n    border-left: none;\n    box-shadow: none;\n    width: 50px;\n\n    &:focus,\n    &:hover,\n    &:active,\n    &:active:focus {\n      background-color: $white;\n      border: 1px solid $form-control-border;\n      border-left: none;\n      box-shadow: none;\n      width: 50px;\n    }\n  }\n\n  .btn.btn-secondary {\n    background-color: $btn-primary;\n    border-radius: 5px;\n    margin-left: 15px;\n    color: #ffffff;\n    font-weight: 300;\n    &:focus,\n    &:hover,\n    &:active,\n    &:active:focus {\n      background-color: $btn-primary;\n    }\n  }\n}\n\n.ingredient-type-ahead__input {\n  height: 2.5rem;\n\n  .form-control {\n    height: 2.5rem;\n    border-color: $form-control-border;\n    border-left: none;\n    border-radius: 0;\n    border-right: none;\n    color: $site-text;\n    height: 2.5rem;\n    position: relative;\n  }\n\n  .form-control:before {\n    position: absolute;\n    top: -10px;\n  }\n}\n\n.table-container {\n  border: solid 1px none;\n  align-items: center;\n  justify-content: center;\n  height: 50vh;\n  overflow-y: scroll;\n}\n\n.ingredient-component-text {\n  font-size: 16px;\n  line-height: 24px;\n  color: #595e60;\n  font-weight: 400;\n  align-items: center;\n  padding: 16px;\n}\n\n.ingredient-component-container-left {\n  border-right: 1px solid #e4f1f0;\n}\n\n.ingredient-component-container-right {\n  border-left: 1px solid #e4f1f0;\n}\n\n.ingredient-component-container {\n  border: 1px solid #e4f1f0;\n}\n\n.custom-checkbox {\n  font-size: 16px;\n  line-height: 24px;\n  color: #595e60;\n  font-weight: 400;\n  align-items: center;\n  padding: 16px;\n\n  .input-checked {\n    cursor: pointer;\n    width: 16px;\n    height: 16px;\n    accent-color: $btn-primary;\n\n    &:checked::before {\n      border: 2px solid #595e60;\n    }\n\n    &:checked::after {\n      border: 3px solid $btn-primary;\n    }\n  }\n}\n\n.common-allergen-type-ahead {\n  background-color: #f5fbff;\n  border: solid 1px #414b4f;\n}\n\n.common-allergen__results {\n  background-color: #f5fbff;\n  box-shadow: 1px 1px 8px 0 rgba(0, 0, 0, 0.2);\n  box-sizing: border-box;\n  margin: auto 15px auto 0;\n  position: absolute;\n  z-index: $dropdown-overlay;\n  overflow-y: scroll;\n  max-height: 40vh;\n  width: 90%;\n  top: 55px;\n\n  .ingredient__option-button {\n    background-color: #f5fbff;\n    border: none;\n    box-shadow: none;\n    color: $site-text;\n    margin: 0;\n    padding: 5px 20px;\n    text-align: start;\n    display: flex;\n    flex: 1;\n\n    mark {\n      background-color: $btn-primary;\n    }\n\n    &:focus,\n    &:hover,\n    &:active,\n    &:active:focus {\n      background-color: $page-background !important;\n      border: 1px solid $site-text !important;\n      border-left: none;\n      border-radius: 0;\n      box-shadow: none;\n      color: $site-text !important;\n    }\n\n    .is-allergen {\n      color: $form-error;\n      font-size: 12px;\n    }\n  }\n  .ingredient__results__none {\n    padding: 20px;\n    width: 100%;\n  }\n}\n\n.footer-button.btn.btn-secondary {\n  background-color: $btn-primary !important;\n  width: 150px;\n  border-radius: 5px;\n}\n\n.loading-container {\n  color: $btn-primary;\n  justify-content: center;\n  align-items: center;\n  margin-top: -200px;\n}\n\n\n","$site-text: #00171f;\n$safe-list: #8e8e93;\n$trans-white: rgba(255, 255, 255, 0.5);\n$trans-grey: rgba(211, 211, 211, 0.5);\n$disabled-link: rgba(142, 142, 147, 0.15);\n$white: #ffffff;\n$page-background: #f5fbff;\n\n$link: #007ea7;\n$font-awesome-icon-color: #85a3ad;\n\n// Buttons\n$btn-color-white: #ffffff;\n$btn-primary: #00889b;\n$secondary: #9db6be;\n$favorite-star: #f9a825;\n\n// Forms\n$form-control-border: #e7edef;\n$form-color: #85a3ad;\n$form-error: #ef6360;\n\n//text color\n$text-normal: #414b4f;\n\n//primary\n$primary-color: #00889b;\n","$dropdown-overlay: 200;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
